import { Component, Story, Knobs, Accents } from './DocTypes';

const BasicStoryKnobs: Knobs = {
  heading: {
    default: 'Basic Wizard',
    editor: 'textbox',
  },
  accent: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
  },
  activeStep: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', 'step1', 'step2', 'step3'],
  },
};
const BasicStory: Story = {
  title: 'Basic',
  description: 'Basic wizard',
  coreComponent: {
    html: `<tag-wizard{{...knobs}}>
  <tag-wizard-step name='step1' heading='Step 1'{{accent}}><div>Content 1</div></tag-wizard-step>
  <tag-wizard-step name='step2' heading='Step 2'{{accent}}><div>Content 2</div></tag-wizard-step>
  <tag-wizard-step name='step3' heading='Step 3'{{accent}}><div>Content 3</div></tag-wizard-step>
</tag-wizard>`,
    knobs: BasicStoryKnobs,
  },
  reactWrapper: {
    jsx: `<TagWizard{{...knobs}}>
  <TagWizardStep name='step1' heading='Step 1'{{accent}}><div>Content 1</div></TagWizardStep>
  <TagWizardStep name='step2' heading='Step 2'{{accent}}><div>Content 2</div></TagWizardStep>
  <TagWizardStep name='step3' heading='Step 3'{{accent}}><div>Content 3</div></TagWizardStep>
</TagWizard>`,
    knobs: BasicStoryKnobs,
  },
};

const ButtonCaptionsStory: Story = {
  title: 'Button captions',
  description: 'Wizard with custom button captions',
  coreComponent: {
    html: `<tag-wizard>
  <tag-wizard-step name='step1' heading='Step 1' next-caption='Step 2'></tag-wizard-step>
  <tag-wizard-step name='step2' heading='Step 2' next-caption='Step 3' previous-caption='Back to step 1'></tag-wizard-step>
  <tag-wizard-step name='step3' heading='Step 3' previous-caption='Back to step 2' finish-caption='Done!'></tag-wizard-step>
</tag-wizard>`,
  },
  reactWrapper: {
    jsx: `<TagWizard>
  <TagWizardStep name='step1' heading='Step 1' nextCaption='Step 2'></TagWizardStep>
  <TagWizardStep name='step2' heading='Step 2' nextCaption='Step 3' previousCaption='Back to step 1'></TagWizardStep>
  <TagWizardStep name='step3' heading='Step 3' previousCaption='Back to step 2' finishCaption='Done!'></TagWizardStep>
</TagWizard>`,
  },
};

const CustomButtonsStory: Story = {
  title: 'Custom Buttons',
  description: 'Wizard with custom buttons',
  coreComponent: {
    html: `<tag-wizard>
  <tag-wizard-step name='step1' heading='Step 1'
    button-1='Button 1' button-1-icon='Bug' button-1-accent='keppel' button-1-icon-accent='white'
    button-2='Button 2' button-2-icon='Badge' button-2-accent='tango' button-2-icon-accent='white' button-2-disabled
    button-3='Button 3' button-3-icon='BlankFace' button-3-accent='sunflower' button-3-icon-accent='white'
    button-4='Button 4' button-4-icon='Castle' button-4-accent='finn' button-4-icon-accent='white'
    button-5='Button 5' button-5-icon='CircleMinus' button-5-accent='plum' button-5-icon-accent='white'>
  </tag-wizard-step>
  <tag-wizard-step name='step2' heading='Step 2'></tag-wizard-step>
</tag-wizard>`,
  },
  reactWrapper: {
    jsx: `<TagWizard>
  <TagWizardStep name='step1' heading='Step 1'
    button1='Button 1' button1Icon='Bug' button1Accent='keppel' button1IconAccent='white'
    button2='Button 2' button2Icon='Badge' button2Accent='tango' button2IconAccent='white' button2Disabled
    button3='Button 3' button3Icon='BlankFace' button3Accent='sunflower' button3IconAccent='white'
    button4='Button 4' button4Icon='Castle' button4Accent='finn' button4IconAccent='white'
    button5='Button 5' button5Icon='CircleMinus' button5Accent='plum' button5IconAccent='white'>
  </TagWizardStep>
  <TagWizardStep name='step2' heading='Step 2' />
</TagWizard>`,
  },
};

const StepCancellationStory: Story = {
  title: 'Step cancellation',
  description: 'Wizard with step movement cancelled',
  coreComponent: {
    html: `<tag-wizard>
  <tag-wizard-step name='step1' heading='Step 1'>
    <div>Shouldn't be able to pass this step</div>
  </tag-wizard-step>
  <tag-wizard-step name='step2' heading='Step 2'></tag-wizard-step>
</tag-wizard>`,
    js: `var tagWizard = document.querySelector('tag-wizard');
tagWizard.componentOnReady().then(function() {
  tagWizard.addEventListener('nextClick', function(e) {
    e.detail.cancel = true;
  });
});`,
  },
  reactWrapper: {
    jsx: `<TagWizard>
  <TagWizardStep
    name='step1'
    heading='step 1'
    onNextClick={e => e.detail.cancel = true}>
    <div>Shouldn't be able to pass this step</div>
  </TagWizardStep>
  <TagWizardStep name='step2' heading='Step 2' />
</TagWizard>`,
  },
};

const StepSkipStory: Story = {
  title: 'Step skip',
  description: 'Wizard with a step being skipped conditionally',
  coreComponent: {
    html: `<tag-wizard>
  <tag-wizard-step name='step1' heading='Step 1' next-step='step3'>
    <tag-checkbox id='check-step1' label='Skip to step 3' checked />
  </tag-wizard-step>
  <tag-wizard-step name='step2' heading='Step 2'>
  </tag-wizard-step>
  <tag-wizard-step name='step3' heading='Step 3' previous-step='step1'>
    <tag-checkbox id='check-step3' label='Skip back to step 1' checked />
  </tag-wizard-step>
</tag-wizard>`,
    js: `var tagWizard = document.querySelector('tag-wizard');

  tagWizard.componentOnReady().then(function() {
    var tagCheckbox1 = document.querySelector('#check-step1');
    tagCheckbox1.addEventListener('valueChange', function(e) {
      var step1 = document.querySelector("tag-wizard-step[name='step1']");
      step1.nextStep = e.detail.value ? 'step3' : undefined;
    });

    var tagCheckbox2 = document.querySelector('#check-step3');
    tagCheckbox2.addEventListener('valueChange', function(e) {
      var step3 = document.querySelector("tag-wizard-step[name='step3']");
      step3.previousStep = e.detail.value ? 'step1' : undefined;
    });
  });`,
  },
  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
    const [step1NextStep, setStep1NextStep] = React.useState("step3");
    const [step3PreviousStep, setStep3PreviousStep] = React.useState("step1");

    return (
      <TagWizard>
        <TagWizardStep name='step1' heading='Step 1' nextStep={step1NextStep}>
          <TagCheckbox label='Skip to step 3' checked onValueChange={e => setStep1NextStep(e.detail.value ? 'step3' : 'step2')} />
        </TagWizardStep>
        <TagWizardStep name='step2' heading='Step 2' />
        <TagWizardStep name='step3' heading='Step 3' previousStep={step3PreviousStep}>
          <TagCheckbox label='Skip back to step 1' checked onValueChange={e => setStep3PreviousStep(e.detail.value ? 'step1' : 'step2')} />
        </TagWizardStep>
      </TagWizard>
    )
  }`,
  },
};

const ButtonDisablingStory: Story = {
  title: 'Button disabling',
  description: 'Wizard with the step next & previous buttons being disabled conditionally',
  coreComponent: {
    html: `<tag-wizard>
  <tag-wizard-step name='step1' heading='Step 1' next-disabled>
    <tag-checkbox id='check-step1' label='Disable next' checked />
  </tag-wizard-step>
  <tag-wizard-step name='step2' heading='Step 2' previous-disabled>
  <tag-checkbox id='check-step2' label='Disable previous' checked />
  </tag-wizard-step>
</tag-wizard>`,
    js: `var tagWizard = document.querySelector('tag-wizard');

  tagWizard.componentOnReady().then(function() {
    var tagCheckbox1 = document.querySelector('#check-step1');
    tagCheckbox1.addEventListener('valueChange', function(e) {
      var step1 = document.querySelector("tag-wizard-step[name='step1']");
      step1.nextDisabled = e.detail.value;
    });

    var tagCheckbox2 = document.querySelector('#check-step2');
    tagCheckbox2.addEventListener('valueChange', function(e) {
      var step2 = document.querySelector("tag-wizard-step[name='step2']");
      step2.previousDisabled = e.detail.value;
    });
  });`,
  },
  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
    const [step1NextDisabled, setStep1NextDisabled] = React.useState(true);
    const [step2PreviousDisabled, setStep2PreviousDisabled] = React.useState(true);

    return (
      <TagWizard>
        <TagWizardStep name='step1' heading='Step 1' nextDisabled={step1NextDisabled}>
          <TagCheckbox label='Disable next' checked onValueChange={e => setStep1NextDisabled(e.detail.value)} />
        </TagWizardStep>
        <TagWizardStep name='step2' heading='Step 2' previousDisabled={step2PreviousDisabled}>
          <TagCheckbox label='Disable previous' checked onValueChange={e => setStep2PreviousDisabled(e.detail.value)} />
        </TagWizardStep>
      </TagWizard>
    )
  }`,
  },
};

const ButtonHidingStory: Story = {
  title: 'Button hiding',
  description: 'Wizard with the step next & previous buttons being conditionally hidden',
  coreComponent: {
    html: `<tag-wizard>
  <tag-wizard-step name='step1' heading='Step 1' next-hidden>
    <tag-checkbox id='check-step1' label='Hide next' checked />
  </tag-wizard-step>
  <tag-wizard-step name='step2' heading='Step 2' previous-hidden>
  <tag-checkbox id='check-step2' label='Hide previous' checked />
  </tag-wizard-step>
</tag-wizard>`,
    js: `var tagWizard = document.querySelector('tag-wizard');

  tagWizard.componentOnReady().then(function() {
    var tagCheckbox1 = document.querySelector('#check-step1');
    tagCheckbox1.addEventListener('valueChange', function(e) {
      var step1 = document.querySelector("tag-wizard-step[name='step1']");
      step1.nextHidden = e.detail.value;
    });

    var tagCheckbox2 = document.querySelector('#check-step2');
    tagCheckbox2.addEventListener('valueChange', function(e) {
      var step2 = document.querySelector("tag-wizard-step[name='step2']");
      step2.previousHidden = e.detail.value;
    });
  });`,
  },

  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
    const [step1NextHidden, setStep1NextHidden] = React.useState(true);
    const [step2PreviousHidden, setStep2PreviousHidden] = React.useState(true);

    return (
      <TagWizard>
        <TagWizardStep name='step1' heading='Step 1' nextHidden={step1NextHidden}>
          <TagCheckbox label='Hide next' checked onValueChange={e => setStep1NextHidden(e.detail.value)} />
        </TagWizardStep>
        <TagWizardStep name='step2' heading='Step 2' previousHidden={step2PreviousHidden}>
          <TagCheckbox label='Hide previous' checked onValueChange={e => setStep2PreviousHidden(e.detail.value)} />
        </TagWizardStep>
      </TagWizard>
    )
  }`,
  },
};

const ModalWizardFormStory: Story = {
  title: 'Modal wizard form',
  description: 'Wizard in a modal form',
  coreComponent: {
    html: `<tag-wizard heading='Your details' modal modal-size='medium' modal-open>
  <tag-wizard-step name='step1' heading='Enter your name' cancel-visible>
      <tag-form-group>
        <tag-edit-field label='Firstname' name='firstName'>
          <tag-validation rule='required'></tag-validation>
        </tag-edit-field>
      </tag-form-group>
      <tag-form-group>
        <tag-edit-field label='Surname' name='surname'>
          <tag-validation rule='required'></tag-validation>
        </tag-edit-field>
      </tag-form-group>
      <tag-form-group>
        <tag-edit-field label='Date of birth' name='date' data-type="date" editor='datepick'></tag-edit-field>
      </tag-form-group>
  </tag-wizard-step>
  <tag-wizard-step name='step2' heading='Step 2' cancel-visible>
    <tag-form-group>
      <tag-edit-field label='Level' name='level' editor='Dropdown' value='2'>
        <tag-edit-field-option value='1'>Level 1</tag-edit-field-option>
        <tag-edit-field-option value='2'>Level 2</tag-edit-field-option>
        <tag-edit-field-option value='3'>Level 3</tag-edit-field-option>
      </tag-edit-field>
    </tag-form-group>
  </tag-wizard-step>
</tag-wizard>`,
  },
  reactWrapper: {
    jsx: `<TagWizard heading='Your details' modal modalSize='medium' modalOpen>
  <TagWizardStep name='step1' heading='Enter your name and DOB' cancelVisible>
      <TagFormGroup>
        <TagEditField label='Firstname' name='firstName' validation={[{rule: 'required'}]} />
      </TagFormGroup>
      <TagFormGroup>
        <TagEditField label='Surname' name='surname' validation={[{rule: 'required'}]} />
      </TagFormGroup>
      <TagFormGroup>
        <TagEditField label='Date of birth' name='date' data-type="date" editor='datepick' />
      </TagFormGroup>
  </TagWizardStep>
  <TagWizardStep name='step2' heading='Enter your level' cancelVisible>
    <TagFormGroup>
      <TagEditField
        label='Level'
        name='level'
        editor='Dropdown'
        value='2'
        options={[{label: 'Level 1', value: 1}, {label: 'Level 2', value: 2}, {label: 'Level 3', value: 3}]}
      />
    </TagFormGroup>
  </TagWizardStep>
</TagWizard>`,
  },
};

const StylingOverridesStory: Story = {
  title: 'Styling overrides',
  description: 'Wizard in a modal form',
  coreComponent: {
    html: `<tag-wizard heading='Wizard' {{headingContainerStyle}}>
  <tag-wizard-step name='Step1' heading='Step 1'{{contentContainerStyle}}{{buttonContainerStyle}}><div>Content 1</div></tag-wizard-step>
  <tag-wizard-step name='Step2' heading='Step 2'{{contentContainerStyle}}{{buttonContainerStyle}}><div>Content 2</div></tag-wizard-step>
</tag-wizard>`,
    knobs: {
      headingContainerStyle: {
        default: '{"display": "none"}',
        editor: 'multilinetextbox',
      },
      contentContainerStyle: {
        default: '{"padding": "15px 20px"}',
        editor: 'multilinetextbox',
      },
      buttonContainerStyle: {
        default: '{"border-top": "#B1B8BF 1px solid"}',
        editor: 'multilinetextbox',
      },
    },
  },
  reactWrapper: {
    jsx: `<TagWizard heading='Wizard' {{headingContainerStyle}}>
  <TagWizardStep name='Step1' heading='Step 1'{{contentContainerStyle}}{{buttonContainerStyle}}><div>Content 1</div></TagWizardStep>
  <TagWizardStep name='Step2' heading='Step 2'{{contentContainerStyle}}{{buttonContainerStyle}}><div>Content 2</div></TagWizardStep>
</TagWizard>`,
    knobs: {
      headingContainerStyle: {
        default: '{"display": "none"}',
        editor: 'multilinetextbox',
        qualifierStart: '{',
        qualifierEnd: '}',
      },
      contentContainerStyle: {
        default: '{"padding": "15px 20px"}',
        editor: 'multilinetextbox',
        qualifierStart: '{',
        qualifierEnd: '}',
      },
      buttonContainerStyle: {
        default: '{"border-top": "#B1B8BF 1px solid"}',
        editor: 'multilinetextbox',
        qualifierStart: '{',
        qualifierEnd: '}',
      },
    },
  },
};

const StepHeadingSlotStory: Story = {
  title: 'Step heading slot',
  description: 'Wizard with a custom step heading element',
  coreComponent: {
    html: `<tag-wizard heading-container-style='{"display": "none"}'>
  <tag-wizard-step name='step1'>
    <div slot='heading' style='display: flex; padding: 15px 20px;'>
      <span style='font-size: 18px; font-weight: bold;'>Branding</span>
      <span style='font-size: 19px; background-color: #007A7A; color: #fff; border-radius: 50%; margin-left: auto; padding: 8px;'>1/2</span>
    </div>
  </tag-wizard-step>
  <tag-wizard-step name='step2'>
  <div slot='heading' style='display: flex; padding: 15px 20px;'>
    <span style='font-size: 18px; font-weight: bold;'>Links</span>
    <span style='font-size: 19px; background-color: #007A7A; color: #fff; border-radius: 50%; margin-left: auto; padding: 8px;'>2/2</span>
  </div>
  </tag-wizard-step>
</tag-wizard>`,
  },
  reactWrapper: {
    jsx: `<TagWizard headingContainerStyle={{display: "none"}}>
  <TagWizardStep name='step1'>
    <div slot='heading' style={{display: "flex", padding: "15px 20px"}}>
      <span style={{fontSize: "18px", fontWeight: "bold"}}>Branding</span>
      <span style={{fontSize: "19px", backgroundColor: "#007A7A", color: "#fff", borderRadius: "50%", marginLeft: "auto", padding: "8px"}}>1/2</span>
    </div>
  </TagWizardStep>
  <TagWizardStep name='step2'>
    <div slot='heading' style={{display: "flex", padding: "15px 20px"}}>
      <span style={{fontSize: "18px", fontWeight: "bold"}}>Links</span>
      <span style={{fontSize: "19px", backgroundColor: "#007A7A", color: "#fff", borderRadius: "50%", marginLeft: "auto", padding: "8px"}}>2/2</span>
    </div>
  </TagWizardStep>
</TagWizard>`,
  },
};

const ButtonStylesStory: Story = {
  title: 'Button styles',
  description: 'Wizard with custom styles for the buttons',
  coreComponent: {
    html: `<tag-wizard>
  <tag-wizard-step
    name='step1'
    next-button-accent='dolphinblue'
    next-button-icon='Arrow2Right'
    next-button-icon-accent='white'
    next-button-icon-container-style='{"display": "flex", "flex-direction": "row-reverse"}'>
  </tag-wizard-step>
  <tag-wizard-step
    name='step2'
    cancel-visible
    cancel-button-style='{"border": "0", "background-color": "transparent"}'
    previous-button-style='{"background-color": "transparent", "border": "solid 1px #007A7A", "color": "#007A7A"}'
    finish-button-accent='dolphinblue'
    finish-button-icon='Tick'
    finish-button-icon-accent='white'>
    </tag-wizard-step>
</tag-wizard>`,
  },
  reactWrapper: {
    jsx: `<TagWizard>
  <TagWizardStep
    name='step1'
    nextButtonAccent='dolphinblue'
    nextButtonIcon='Arrow2Right'
    nextButtonIconAccent='white'
    nextButtonIconContainerStyle={{display: "flex", flexDirection: "row-reverse"}}
  />
  <TagWizardStep
    name='step2'
    cancelVisible
    cancelButtonStyle={{border: "0", backgroundColor: "transparent"}}
    previousButtonStyle={{backgroundColor: "transparent", border: "solid 1px #007A7A", color: "#007A7A"}}
    finishButtonAccent='dolphinblue'
    finishButtonIcon='Tick'
    finishButtonIconAccent='white'
  />
</TagWizard>`,
  },
};

const ControllingActiveStepStory: Story = {
  title: 'Controlling active step',
  description: 'A wizard in React where the active step is controlled by state',

  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
    const [activeStep, setActiveStep] = React.useState('step1');
    return (
      <React.Fragment>
        <p>Active step: {activeStep}</p>
        <TagEditField
          label='Go to step'
          editor='dropdown'
          options={[
            {label: 'Step 1', value: 'step1'},
            {label: 'Step 2', value: 'step2'},
            {label: 'Step 3', value: 'step3'},
          ]}
          value={activeStep}
          onValueChange={e => setActiveStep(e.detail.value)}
        />
        <TagWizard
          heading='Controlling active step with state'
          activeStep={activeStep}
          onActiveStepChange={e => setActiveStep(e.detail.name) }
        >
          <TagWizardStep name='step1' heading='Step 1'><div>Content 1</div></TagWizardStep>
          <TagWizardStep name='step2' heading='Step 2'><div>Content 2</div></TagWizardStep>
          <TagWizardStep name='step3' heading='Step 3'><div>Content 3</div></TagWizardStep>
        </TagWizard>
      </React.Fragment>
    )
  }`,
  },
};

const EditableTableStory: Story = {
  title: 'Editable Table',
  description:
    'One step of the wizard will contain a editable table with a date column and other columns and a column picker',
  coreComponent: {
    html: `
  <tag-wizard>
    <tag-wizard-step name='step1' heading='Step 1'>
      <tag-table show-column-picker cache-columns>
        <tag-table-column name='task' caption='Task' cell-width='120px'>
          <tag-table-column-editor max-length='20' placeholder='Enter Task'>
          </tag-table-column-editor>
        </tag-table-column>
        <tag-table-column name='dueDate' caption='Due Date' cell-width='100px'>
          <tag-table-column-editor type='datepick'>
          </tag-table-column-editor>
        </tag-table-column>
      </tag-table>
    </tag-wizard-step>
    <tag-wizard-step name='step2' heading='Step 2'><div>Content 2</div></tag-wizard-step>
  </tag-wizard>`,
    js: `var tagTable = document.querySelector('tag-table');
  tagTable.data = [
    {
      task: 'Cut the grass',
      dueDate: new Date(),
    },
    {
      task: 'Do the shopping',
      dueDate: new Date(),
    },
    {
      task: 'Cut the grass',
      dueDate: new Date(),
    },
    {
      task: 'Do the shopping',
      dueDate: new Date(),
    },
  ];
  `,
  },
  reactWrapper: {
    jsx: `
  <TagWizard>
    <TagWizardStep name='step1' heading='Step 1'>
      <TagTable showColumnPicker cacheColumns
        columns={[
          {
            name:'task',
            caption:'Task',
            editor: {
              maxLength:'20',
              placeholder:'Enter Task',
              inline: true,
            }
          },
          {
            name:'dueDate',
            caption:'Due Date',
            editor: {
              type:'datepick',
              inline: true,
            }
          },
        ]}
        data={[
          {
            task: 'Cut the grass',
            dueDate: new Date(),
          },
          {
            task: 'Do the shopping',
            dueDate: new Date(),
          },
          {
            task: 'Cut the grass',
            dueDate: new Date(),
          },
          {
            task: 'Do the shopping',
            dueDate: new Date(),
          },
        ]}
      />
    </TagWizardStep>
    <TagWizardStep name='step2' heading='Step 2'><div>Content 2</div></TagWizardStep>
  </TagWizard>`,
  },
};

const TagWizardStepDocs: Component = {
  type: 'component',
  name: 'wizard-step',
  description: 'Specifies a step for tag-wizard',
  mobileFriendly: false,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'name',
      description: 'The step name',
      type: 'string',
    },
    {
      name: 'containerStyle',
      description: 'JSON CSS container style',
      type: 'string',
    },
    {
      name: 'heading',
      description: 'The step heading',
      type: 'string',
    },
    {
      name: 'accent',
      description: 'The accent colour for the wizard step',
      type: 'string',
    },
    {
      name: 'buttonContainerStyle',
      description: 'JSON CSS container style for the button',
      type: 'string',
    },
    {
      name: 'previousStep',
      description: 'The previous step name if not the one directly before',
      type: 'string',
    },
    {
      name: 'previousCaption',
      description: 'The previous button caption',
      type: 'string',
    },
    {
      name: 'previousDisabled',
      description: 'Whether the previous button is disabled',
      type: 'boolean',
    },
    {
      name: 'previousHidden',
      description: 'Whether the previous button is hidden',
      type: 'boolean',
    },
    {
      name: 'previousButtonAccent',
      description: 'The accent for the button',
      type: 'boolean',
    },
    {
      name: 'previousButtonIcon',
      description: 'The icon for the button',
      type: 'boolean',
    },
    {
      name: 'previousButtonIconAccent',
      description: 'The icon accent for the button',
      type: 'boolean',
    },
    {
      name: 'previousButtonStyle',
      description: 'JSON CSS style for the button',
      type: 'string',
    },
    {
      name: 'previousButtonTextStyle',
      description: 'JSON CSS style for the button text',
      type: 'string',
    },
    {
      name: 'previousButtonTextContainerStyle',
      description: 'JSON CSS style for the button text container',
      type: 'string',
    },
    {
      name: 'previousButtonIconStyle',
      description: 'JSON CSS style for the button icon',
      type: 'string',
    },
    {
      name: 'previousButtonIconContainerStyle',
      description: 'JSON CSS style for the button icon container',
      type: 'string',
    },
    {
      name: 'nextStep',
      description: 'The next step name if not the one directly after',
      type: 'string',
    },
    {
      name: 'nextCaption',
      description: 'The next button caption',
      type: 'string',
    },
    {
      name: 'nextDisabled',
      description: 'Whether the next button is disabled',
      type: 'boolean',
    },
    {
      name: 'nextHidden',
      description: 'Whether the next button is hidden',
      type: 'boolean',
    },
    {
      name: 'nextButtonAccent',
      description: 'The accent for the button',
      type: 'boolean',
    },
    {
      name: 'nextButtonIcon',
      description: 'The icon for the button',
      type: 'boolean',
    },
    {
      name: 'nextButtonIconAccent',
      description: 'The icon accent for the button',
      type: 'boolean',
    },
    {
      name: 'nextButtonStyle',
      description: 'JSON CSS style for the button',
      type: 'string',
    },
    {
      name: 'nextButtonTextStyle',
      description: 'JSON CSS style for the button text',
      type: 'string',
    },
    {
      name: 'nextButtonTextContainerStyle',
      description: 'JSON CSS style for the button text container',
      type: 'string',
    },
    {
      name: 'nextButtonIconStyle',
      description: 'JSON CSS style for the button icon',
      type: 'string',
    },
    {
      name: 'nextButtonIconContainerStyle',
      description: 'JSON CSS style for the button icon container',
      type: 'string',
    },
    {
      name: 'finishCaption',
      description: 'The finish button caption',
      type: 'string',
    },
    {
      name: 'finishButtonAccent',
      description: 'The accent for the button',
      type: 'boolean',
    },
    {
      name: 'finishButtonIcon',
      description: 'The icon for the button',
      type: 'boolean',
    },
    {
      name: 'finishButtonIconAccent',
      description: 'The icon accent for the button',
      type: 'boolean',
    },
    {
      name: 'finishButtonStyle',
      description: 'JSON CSS style for the button',
      type: 'string',
    },
    {
      name: 'finishButtonTextStyle',
      description: 'JSON CSS style for the button text',
      type: 'string',
    },
    {
      name: 'finishButtonTextContainerStyle',
      description: 'JSON CSS style for the button text container',
      type: 'string',
    },
    {
      name: 'finishButtonIconStyle',
      description: 'JSON CSS style for the button icon',
      type: 'string',
    },
    {
      name: 'finishButtonIconContainerStyle',
      description: 'JSON CSS style for the button icon container',
      type: 'string',
    },
    {
      name: 'finishHidden',
      description: 'Whether the finish button is hidden',
      type: 'boolean',
    },
    {
      name: 'cancelCaption',
      description: 'The cancel button caption',
      type: 'string',
    },
    {
      name: 'cancelDisabled',
      description: 'Whether the cancel button is disabled',
      type: 'boolean',
    },
    {
      name: 'cancelVisible',
      description: 'Whether the cancel button is visible',
      type: 'boolean',
    },
    {
      name: 'cancelButtonAccent',
      description: 'The accent for the button',
      type: 'boolean',
    },
    {
      name: 'cancelButtonIcon',
      description: 'The icon for the button',
      type: 'boolean',
    },
    {
      name: 'cancelButtonIconAccent',
      description: 'The icon accent for the button',
      type: 'boolean',
    },
    {
      name: 'cancelButtonStyle',
      description: 'JSON CSS style for the button',
      type: 'string',
    },
    {
      name: 'cancelButtonTextStyle',
      description: 'JSON CSS style for the button text',
      type: 'string',
    },
    {
      name: 'cancelButtonTextContainerStyle',
      description: 'JSON CSS style for the button text container',
      type: 'string',
    },
    {
      name: 'cancelButtonIconStyle',
      description: 'JSON CSS style for the button icon',
      type: 'string',
    },
    {
      name: 'cancelButtonIconContainerStyle',
      description: 'JSON CSS style for the button icon container',
      type: 'string',
    },
    {
      name: 'button1',
      description: 'Caption of the first custom button',
      type: 'string',
    },
    {
      name: 'button1Icon',
      description: 'Icon of the first custom button',
      type: 'string',
    },
    {
      name: 'button1IconAccent',
      description: 'Accent of the first custom button icon',
      type: 'string',
    },
    {
      name: 'button1Accent',
      description: 'Accent of the first custom button',
      type: 'string',
    },
    {
      name: 'button1Disabled',
      description: 'Whether the first custom button is disabled',
      type: 'boolean',
    },
    {
      name: 'button1Style',
      description: 'JSON CSS style for the button',
      type: 'string',
    },
    {
      name: 'button1TextStyle',
      description: 'JSON CSS style for the button text',
      type: 'string',
    },
    {
      name: 'button1TextContainerStyle',
      description: 'JSON CSS style for the button text container',
      type: 'string',
    },
    {
      name: 'button1IconStyle',
      description: 'JSON CSS style for the button icon',
      type: 'string',
    },
    {
      name: 'button1IconContainerStyle',
      description: 'JSON CSS style for the button icon container',
      type: 'string',
    },
    {
      name: 'button2',
      description: 'Caption of the second custom button',
      type: 'string',
    },
    {
      name: 'button2Icon',
      description: 'Icon of the second custom button',
      type: 'string',
    },
    {
      name: 'button2IconAccent',
      description: 'Accent of the second custom button icon',
      type: 'string',
    },
    {
      name: 'button2Accent',
      description: 'Accent of the second custom button',
      type: 'string',
    },
    {
      name: 'button2Disabled',
      description: 'Whether the second custom button is disabled',
      type: 'boolean',
    },
    {
      name: 'button2Style',
      description: 'JSON CSS style for the button',
      type: 'string',
    },
    {
      name: 'button2TextStyle',
      description: 'JSON CSS style for the button text',
      type: 'string',
    },
    {
      name: 'button2TextContainerStyle',
      description: 'JSON CSS style for the button text container',
      type: 'string',
    },
    {
      name: 'button2IconStyle',
      description: 'JSON CSS style for the button icon',
      type: 'string',
    },
    {
      name: 'button2IconContainerStyle',
      description: 'JSON CSS style for the button icon container',
      type: 'string',
    },
    {
      name: 'button3',
      description: 'Caption of the third custom button',
      type: 'string',
    },
    {
      name: 'button3Icon',
      description: 'Icon of the third custom button',
      type: 'string',
    },
    {
      name: 'button3IconAccent',
      description: 'Accent of the third custom button icon',
      type: 'string',
    },
    {
      name: 'button3Accent',
      description: 'Accent of the third custom button',
      type: 'string',
    },
    {
      name: 'button3Disabled',
      description: 'Whether the third custom button is disabled',
      type: 'boolean',
    },
    {
      name: 'button3Style',
      description: 'JSON CSS style for the button',
      type: 'string',
    },
    {
      name: 'button3TextStyle',
      description: 'JSON CSS style for the button text',
      type: 'string',
    },
    {
      name: 'button3TextContainerStyle',
      description: 'JSON CSS style for the button text container',
      type: 'string',
    },
    {
      name: 'button3IconStyle',
      description: 'JSON CSS style for the button icon',
      type: 'string',
    },
    {
      name: 'button3IconContainerStyle',
      description: 'JSON CSS style for the button icon container',
      type: 'string',
    },
    {
      name: 'button4',
      description: 'Caption of the fourth custom button',
      type: 'string',
    },
    {
      name: 'button4Icon',
      description: 'Icon of the fourth custom button',
      type: 'string',
    },
    {
      name: 'button4IconAccent',
      description: 'Accent of the fourth custom button icon',
      type: 'string',
    },
    {
      name: 'button4Accent',
      description: 'Accent of the fourth custom button',
      type: 'string',
    },
    {
      name: 'button4Disabled',
      description: 'Whether the fourth custom button is disabled',
      type: 'boolean',
    },
    {
      name: 'button4Style',
      description: 'JSON CSS style for the button',
      type: 'string',
    },
    {
      name: 'button4TextStyle',
      description: 'JSON CSS style for the button text',
      type: 'string',
    },
    {
      name: 'button4TextContainerStyle',
      description: 'JSON CSS style for the button text container',
      type: 'string',
    },
    {
      name: 'button4IconStyle',
      description: 'JSON CSS style for the button icon',
      type: 'string',
    },
    {
      name: 'button4IconContainerStyle',
      description: 'JSON CSS style for the button icon container',
      type: 'string',
    },
    {
      name: 'button5',
      description: 'Caption of the fifth custom button',
      type: 'string',
    },
    {
      name: 'button5Icon',
      description: 'Icon of the fifth custom button',
      type: 'string',
    },
    {
      name: 'button5IconAccent',
      description: 'Accent of the fifth custom button icon',
      type: 'string',
    },
    {
      name: 'button5Accent',
      description: 'Accent of the fifth custom button',
      type: 'string',
    },
    {
      name: 'button5Disabled',
      description: 'Whether the fifth custom button is disabled',
      type: 'boolean',
    },
    {
      name: 'button5Style',
      description: 'JSON CSS style for the button',
      type: 'string',
    },
    {
      name: 'button5TextStyle',
      description: 'JSON CSS style for the button text',
      type: 'string',
    },
    {
      name: 'button5TextContainerStyle',
      description: 'JSON CSS style for the button text container',
      type: 'string',
    },
    {
      name: 'button5IconStyle',
      description: 'JSON CSS style for the button icon',
      type: 'string',
    },
    {
      name: 'button5IconContainerStyle',
      description: 'JSON CSS style for the button icon container',
      type: 'string',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'previousClick',
      description: 'Raised when the previous button is pressed',
      parameters: [
        {
          name: 'step',
          description: 'Step name',
          type: 'string',
        },
        {
          name: 'cancel',
          description: 'Flag to cancel the step move',
          type: 'boolean',
        },
        {
          name: 'fieldValues',
          description: 'The fields values in the step',
          type: '{[key:string]: any}',
        },
      ],
    },
    {
      name: 'nextClick',
      description: 'Raised when the next button is pressed',
      parameters: [
        {
          name: 'step',
          description: 'Step name',
          type: 'string',
        },
        {
          name: 'cancel',
          description: 'Flag to cancel the step move',
          type: 'boolean',
        },
        {
          name: 'fieldValues',
          description: 'The fields values in the step',
          type: '{[key:string]: any}',
        },
      ],
    },
    {
      name: 'cancelClick',
      description: 'Raised when the cancel button is pressed',
      parameters: [],
    },
    {
      name: 'finishClick',
      description: 'Raised when the finish button is pressed',
      parameters: [
        {
          name: 'cancel',
          description: 'Flag to cancel the step move',
          type: 'boolean',
        },
        {
          name: 'fieldValues',
          description: 'The fields values in the step',
          type: '{[key:string]: any}',
        },
      ],
    },
    {
      name: 'button1Click',
      description: 'Raised when the first button is pressed',
      parameters: [
        {
          name: 'step',
          description: 'Step name',
          type: 'string',
        },
        {
          name: 'button',
          description: 'Button name',
          type: 'string',
        },
        {
          name: 'fieldValues',
          description: 'The fields values in the step',
          type: '{[key:string]: any}',
        },
      ],
    },
    {
      name: 'button2Click',
      description: 'Raised when the second button is pressed',
      parameters: [
        {
          name: 'step',
          description: 'Step name',
          type: 'string',
        },
        {
          name: 'button',
          description: 'Button name',
          type: 'string',
        },
        {
          name: 'fieldValues',
          description: 'The fields values in the step',
          type: '{[key:string]: any}',
        },
      ],
    },
    {
      name: 'button3Click',
      description: 'Raised when the third button is pressed',
      parameters: [
        {
          name: 'step',
          description: 'Step name',
          type: 'string',
        },
        {
          name: 'button',
          description: 'Button name',
          type: 'string',
        },
        {
          name: 'fieldValues',
          description: 'The fields values in the step',
          type: '{[key:string]: any}',
        },
      ],
    },
    {
      name: 'button4Click',
      description: 'Raised when the forth button is pressed',
      parameters: [
        {
          name: 'step',
          description: 'Step name',
          type: 'string',
        },
        {
          name: 'button',
          description: 'Button name',
          type: 'string',
        },
        {
          name: 'fieldValues',
          description: 'The fields values in the step',
          type: '{[key:string]: any}',
        },
      ],
    },
    {
      name: 'button5Click',
      description: 'Raised when the fifth button is pressed',
      parameters: [
        {
          name: 'step',
          description: 'Step name',
          type: 'string',
        },
        {
          name: 'button',
          description: 'Button name',
          type: 'string',
        },
        {
          name: 'fieldValues',
          description: 'The fields values in the step',
          type: '{[key:string]: any}',
        },
      ],
    },
  ],
  methods: [],
  stories: [],
};

export const TagWizardDocs: Component = {
  type: 'component',
  name: 'wizard',
  description: 'Renders a series screens in steps',
  mobileFriendly: false,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'modal',
      description: 'Whether the wizard is in a modal',
      type: 'boolean',
    },
    {
      name: 'modalOpen',
      description: 'Whether the wizard modal is open',
      type: 'boolean',
    },
    {
      name: 'modalSize',
      description: 'The wizard modal size',
      type: 'small | medium | large',
      default: 'medium',
    },
    {
      name: 'headingContainerStyle',
      description: 'JSON CSS container style for heading',
      type: 'string',
    },
    {
      name: 'heading',
      description: 'The wizard heading',
      type: 'string',
    },
    {
      name: 'accent',
      description: 'The accent colour for the wizard',
      type: 'string',
    },
    {
      name: 'height',
      description: 'The height of the wizard',
      type: 'string',
    },
    {
      name: 'activeStep',
      description: 'The current active step name. This will switch the step, once set',
      type: 'string',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'closed',
      description: 'Raised when the modal is closed',
      parameters: [],
    },
    {
      name: 'opened',
      description: 'Raised when the modal is opened',
      parameters: [],
    },
    {
      name: 'previousClick',
      description: 'Raised when the previous button is pressed',
      parameters: [
        {
          name: 'step',
          description: 'Step name',
          type: 'string',
        },
        {
          name: 'cancel',
          description: 'Flag to cancel the step move',
          type: 'boolean',
        },
        {
          name: 'fieldValues',
          description: 'The fields values in the step',
          type: '{[key:string]: any}',
        },
      ],
    },
    {
      name: 'nextClick',
      description: 'Raised when the next button is pressed',
      parameters: [
        {
          name: 'step',
          description: 'Step name',
          type: 'string',
        },
        {
          name: 'cancel',
          description: 'Flag to cancel the step move',
          type: 'boolean',
        },
        {
          name: 'fieldValues',
          description: 'The fields values in the step',
          type: '{[key:string]: any}',
        },
      ],
    },
    {
      name: 'cancelClick',
      description: 'Raised when the cancel button is pressed',
      parameters: [],
    },
    {
      name: 'finishClick',
      description: 'Raised when the finish button is pressed',
      parameters: [
        {
          name: 'cancel',
          description: 'Flag to cancel the step move',
          type: 'boolean',
        },
        {
          name: 'fieldValues',
          description: 'The fields values in the step',
          type: '{[key:string]: any}',
        },
      ],
    },
    {
      name: 'button1Click',
      description: 'Raised when the first button is pressed',
      parameters: [
        {
          name: 'step',
          description: 'Step name',
          type: 'string',
        },
        {
          name: 'button',
          description: 'Button name',
          type: 'string',
        },
        {
          name: 'fieldValues',
          description: 'The fields values in the step',
          type: '{[key:string]: any}',
        },
      ],
    },
    {
      name: 'button2Click',
      description: 'Raised when the second button is pressed',
      parameters: [
        {
          name: 'step',
          description: 'Step name',
          type: 'string',
        },
        {
          name: 'button',
          description: 'Button name',
          type: 'string',
        },
        {
          name: 'fieldValues',
          description: 'The fields values in the step',
          type: '{[key:string]: any}',
        },
      ],
    },
    {
      name: 'button3Click',
      description: 'Raised when the third button is pressed',
      parameters: [
        {
          name: 'step',
          description: 'Step name',
          type: 'string',
        },
        {
          name: 'button',
          description: 'Button name',
          type: 'string',
        },
        {
          name: 'fieldValues',
          description: 'The fields values in the step',
          type: '{[key:string]: any}',
        },
      ],
    },
    {
      name: 'button4Click',
      description: 'Raised when the forth button is pressed',
      parameters: [
        {
          name: 'step',
          description: 'Step name',
          type: 'string',
        },
        {
          name: 'button',
          description: 'Button name',
          type: 'string',
        },
        {
          name: 'fieldValues',
          description: 'The fields values in the step',
          type: '{[key:string]: any}',
        },
      ],
    },
    {
      name: 'button5Click',
      description: 'Raised when the fifth button is pressed',
      parameters: [
        {
          name: 'step',
          description: 'Step name',
          type: 'string',
        },
        {
          name: 'button',
          description: 'Button name',
          type: 'string',
        },
        {
          name: 'fieldValues',
          description: 'The fields values in the step',
          type: '{[key:string]: any}',
        },
      ],
    },
    {
      name: 'activeStepChange',
      description: 'Raised when the active step changes',
      parameters: [
        {
          name: 'name',
          description: 'The new step name',
          type: 'string',
        },
      ],
    },
  ],
  methods: [
    {
      name: 'show',
      description: 'Shows the modal',
      parameters: [],
      returnType: 'void',
    },
    {
      name: 'Hide',
      description: 'Hides the modal',
      parameters: [],
      returnType: 'void',
    },
  ],
  stories: [
    BasicStory,
    ButtonCaptionsStory,
    CustomButtonsStory,
    StepCancellationStory,
    StepSkipStory,
    ButtonDisablingStory,
    ControllingActiveStepStory,
    ButtonHidingStory,
    ModalWizardFormStory,
    StylingOverridesStory,
    StepHeadingSlotStory,
    ButtonStylesStory,
    EditableTableStory,
  ],
  childComponents: [TagWizardStepDocs],
};
